import React from 'react';
import styled from 'styled-components';
import { tokens, palette } from '../../styles';

const Hr = styled.hr`
  width: 100%;
  height: 1px;
  border: 0;
  border-top: 1px solid ${palette['color-grey-200']};
  margin: ${tokens.spacing.l} 0;
`;

const Divider = () => {
  return <Hr />;
};

export default Divider;
